export const CUSTOMIZATION_CURRENT = 'customization/CURRENT';
export const CUSTOMIZATION_FETCH = 'customization/FETCH';
export const CUSTOMIZATION_DATA = 'customization/DATA';
export const CUSTOMIZATION_ERROR = 'customization/ERROR';
